<template>
  <div id="loginPage">
    <div style="display: flex; height: 100vh;">
      <div id="loginContainer" style="margin-left: auto; margin-right: auto; align-items: center;">
        <div :class="{ failure: failure }" ref="loginCard">
          <div class="card bordernone bs-small" style="margin-top: 200px;">
            <div class="card-header bggreen text-white" style="padding: 20px 1.25rem;">
              <div  style="display: flex;">
                <img
                  class="mw100"
                  src="@/assets/img/cube.png"
                  style="max-width: 30px; max-height: 30px"
                />
                <h4 class="mb0 ml10">Forgot My Password</h4>
              </div>
            </div>
            <div class="card-body" ref="cardBody">
              <div v-if="!unsupported">
                <h6 v-if="maintenanceMode" style="color: #e25353">
                  Under Maintenance, sorry for the inconvenience
                </h6>
                <h6 v-else-if="locked" style="color: #e25353">
                  We've temporarily locked your account after too many failed requests. Please contact the Spacesaver IT dept.
                </h6>
                <form @submit.prevent="resetPW">
                  <small v-if="usedEmail" style="color: #6f6e6e">
                    There is an issue with your username
                  </small>
                  <small style="display: block; margin-bottom: 20px; color: #575757; text-align: left;">
                    Please enter the email address associated with your SpaceNET account. You will receive an email with a verification code to reset your password. If you encounter any issues, please contact us at 
                    <a href="mailto:spacenet3feedback@spacesaver.com" style="color: #00b4b4;">
                      spacenet3feedback@spacesaver.com
                    </a>.
                  </small>
                  <div class="input-group mb-3">
                    <input
                      class="form-control"
                      type="text"
                      v-model="email"
                      placeholder="Email Address"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <span class="material-icons" style="font-size: 20px; color: #777373;">
                        mail
                        </span>
                      </span>
                    </div>
                  </div>
                  <input
                    class="form-control"
                    type="hidden"
                    v-model="bot"
                    placeholder="Email Address"
                  />
                  <div class="form-group mt-4">
                    <button
                      v-if="maintenanceMode || locked"
                      disabled
                      class="loginbtn"
                      style="width: 70.05px; height: 34px"
                    >
                      <span v-if="!sending">Submit</span>
                      <span v-else>
                        <looping-rhombuses-spinner
                          :animation-duration="1000"
                          :rhombus-size="6"
                          color="#fff"
                        />
                      </span>
                    </button>
                    <button
                      v-else
                      class="loginbtn"
                      style="width: 70.05px; height: 34px"
                    >
                      <span v-if="!sending">Submit</span>
                      <span v-else>
                        <looping-rhombuses-spinner
                          :animation-duration="1000"
                          :rhombus-size="6"
                          color="#fff"
                        />
                      </span>
                    </button>
                  </div>
                  <p style="text-align: left;">
                    <router-link to="/" class="login-link">
                      <small>Back to Login</small>
                    </router-link>
                  </p>
                </form>
              </div>

              <!-- Unsupported Browser -->
              <div v-else>
                <h6>
                  It looks like you are using an outdated web browser. In order to have a consistent experience, we suggest using a safer browser that follows current web standards. Here are a few good options!
                </h6>
                <hr />
                <ul class="browser-list" style="display: flex; justify-content: space-around; padding: 0; list-style: none;">
                  <li>
                    <a
                      href="https://www.google.com/chrome/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        class="mw100"
                        src="@/assets/img/chrome.png"
                        style="max-width: 50px; max-height: 50px"
                        alt="Google Chrome"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.mozilla.org/en-US/firefox/new/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        class="mw100"
                        src="@/assets/img/firefox.png"
                        style="max-width: 50px; max-height: 50px"
                        alt="Mozilla Firefox"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.microsoft.com/en-us/edge"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        class="mw100"
                        src="@/assets/img/edge.png"
                        style="max-width: 50px; max-height: 50px"
                        alt="Microsoft Edge"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://support.apple.com/en_AU/downloads/safari"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        class="mw100"
                        src="@/assets/img/safari.png"
                        style="max-width: 50px; max-height: 50px"
                        alt="Apple Safari"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { LoopingRhombusesSpinner } from "epic-spinners";
import { gsap } from 'gsap';
// import VueRecaptcha from "vue-recaptcha";

//import shared from '@/state';

export default {
  name: "Forgot",
  components: {
    LoopingRhombusesSpinner,
    // "vue-recaptcha": VueRecaptcha,
  },
  data() {

    return {
      url: import.meta.env.VITE_APP_URL,
      title: import.meta.env.VITE_APP_TITLE,
      bot: "",
      email: "",
      password: "",
      failure: false,
      error: null,
      feedback: "",
      errors: [],
      sending: false,
      maintenanceMode: false,
      locked: false,
      unsupported: false,
      userIP: "",
      robot: false,
      usedEmail: false,
      showPW: false,
    };
    
  },

  methods: {

    animateLoginCard() {
      const tl = gsap.timeline();

      tl.from(this.$refs.loginCard, {
        duration: 1,
        y: 50,
        opacity: 0,
        ease: 'power2.out',
      })
        .from(
          this.$refs.cardHeader,
          {
            duration: 1,
            opacity: 0,
            x: 0,
            ease: 'power1.out',
          },
        )
       
    },

    animateRecaptcha() {
      gsap.from(this.$refs.recaptchaGroup, {
        duration: 0.8, // Smooth fade duration
        opacity: 0,
        ease: 'power1.out',
      },'-=0.1');
    },

    animateFailure() {

      gsap.to(this.$refs.loginCard, {
        duration: 0.3, // Faster shakes
        x: -10,
        repeat: 2, // 3 total shakes (1 initial + 2 repeats)
        yoyo: true, // Back and forth
        ease: 'power1.out', // Faster at the end of each cycle
        onComplete: () => gsap.set(this.$refs.loginCard, { x: 0 }), // Reset position
      });

    },

    refreshPage: function () {
      //this.$router.go();
      //refresh to get the newest update
      // this.$forceUpdate();
    },

    checkUserLock: function () {
      console.log("Check to see of the user is locked");
    },

    showPass: function () {
      this.showPW = true;
    },

    hidePass: function () {
      this.showPW = false;
    },

    resetPW() {

      if(!this.bot.length){
         this.sending = true;
      let postData = {
        email: this.email,
      };
      let axiosConfig = {
				headers: {
					"Content-Type": "application/json;charset=UTF-8",
				},
			};
			return axios
			
				.post(`${import.meta.env.VITE_APP_SERVER_URL}/api/v1/forgot-password`, postData, axiosConfig)
				.then((response) => {
					//console.log(response);
					if (response.data.type == 'success') {

            this.sending = false;
						this.$toast.success("A password reset link was sent. Click the link in the email to create a new password.", { hideProgressBar: false, icon: false });
						this.$router.push("/reset");
						return true;

					} else {

            this.failure = true;
            setTimeout(() => this.failure = false, 2000);
            this.sending = false;
						this.$toast.error("There seems to be an issue with your credentials.", { hideProgressBar: false, icon: false });
						return false;
					}


				})
				.catch((err) => {
					console.log(err);
          this.sending = false;
          this.failure = true;
          setTimeout(() => this.failure = false, 2000);
          this.$toast.error("There seems to be an issue with your credentials.", { hideProgressBar: false, icon: false });
					return false;
				});
      } else {
        this.sending = false;
        this.$toast.error("Please come back when you are human.", { hideProgressBar: false, icon: false });
      }     
    },


    onVerify: function (response) {
      if (response) this.robot = true;
    },

    /*
    showNavigation() {
      this.$store.commit("showNavigation");
    },

    hideNavigation() {
      this.$store.commit("hideNavigation");
    },
    */

    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },

    checkEmail(emailAddress) {
      var sQtext = "[^\\x0d\\x22\\x5c\\x80-\\xff]";
      var sDtext = "[^\\x0d\\x5b-\\x5d\\x80-\\xff]";
      var sAtom =
        "[^\\x00-\\x20\\x22\\x28\\x29\\x2c\\x2e\\x3a-\\x3c\\x3e\\x40\\x5b-\\x5d\\x7f-\\xff]+";
      var sQuotedPair = "\\x5c[\\x00-\\x7f]";
      var sDomainLiteral = "\\x5b(" + sDtext + "|" + sQuotedPair + ")*\\x5d";
      var sQuotedString = "\\x22(" + sQtext + "|" + sQuotedPair + ")*\\x22";
      var sDomain_ref = sAtom;
      var sSubDomain = "(" + sDomain_ref + "|" + sDomainLiteral + ")";
      var sWord = "(" + sAtom + "|" + sQuotedString + ")";
      var sDomain = sSubDomain + "(\\x2e" + sSubDomain + ")*";
      var sLocalPart = sWord + "(\\x2e" + sWord + ")*";
      var sAddrSpec = sLocalPart + "\\x40" + sDomain; // complete RFC822 email address spec
      var sValidEmail = "^" + sAddrSpec + "$"; // as whole string

      var reValidEmail = new RegExp(sValidEmail);

      return reValidEmail.test(emailAddress);
    },
    detectIE() {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");

      //if (msie > 0 || navigator.userAgent.match(/Trident.*rv\:11\./)) {
      if (msie > 0 || msie == 11) {
        // If Internet Explorer, return version number
        //alert(parseInt(ua.substring(msie + 5, ua.indexOf(".", msie))));
        this.unsupported = true;
      } // If another browser, return 0
      else {
        // alert("otherbrowser");
        return;
      }

      return false;
    },
  },
  mounted() {
    this.animateLoginCard();
  },

  computed: {
    //returns if the nav is open or closed
    navigationState() {
      return this.$store.state.nav;
    },

  },

  created() {
    this.refreshPage();
    localStorage.removeItem("SSCUSER");
    // this.$store.commit("hideNavigation");
    // this.toggleBodyClass("removeClass", "wsactive");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("SSCUSER");
    this.detectIE();
    //console.log(this.$router);
    // console.log(this.$route.query.from);
    fetch("https://api.ipify.org?format=json")
      .then((x) => x.json())
      .then(({ ip }) => {
        this.userIP = ip;
      });
    //console.log(window.innerWidth);
  },
  watch: {
/*
    failure(newVal) {
      if (newVal) this.animateFailure();
    },
 */ 
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.card-header {
  display: flex;
  display: flex;
  align-items: center;
}

.login {
  display: none;
}
.mt200 {
  margin-top: 200px;
}
.bggreen {
  background: #00b4b4;
}
.green {
  color: #00b4b4;
}
.bordernone {
  border: none;
}
.mt15 {
  margin-top: 15px;
}

.bs {
  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}
.card-header {
  border-bottom: none;
}
.loginbtn {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  background: #00b4b4;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  padding: 5px 15px;
}
.mb0 {
  margin-bottom: 0 !important;
}

.ml10 {
  margin-left: 10px;
}
.login-link {
  cursor: pointer;
  color: #00b4b4;
  line-height: 1;
}

#loginPage {
  height: 100vh !important;
  width: 100vw !important;
}

#loginPage {
  height: 100vh !important;
  width: 100vw !important;
  /*background-image: linear-gradient(45deg, rgba(66,66,66, 0.96), rgba(8,83,156, 0.45)), url('SpaceSaver-0041.jpeg');*/
    
    width: 100%;
    background-size: cover;
    text-align: center;
    background-position: center;
    color: #fff;
    background-color: #DDE3EA;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cg stroke='%23D8DEE5' stroke-width='0' stroke-miterlimit='99' %3E%3Cpolygon fill='%23E2E8F0' points='-70 85 100 0 0 150 200 0 0 300 350 0 0 500 550 0 0 750 800 0 0 1050 1100 0 0 1400 1450 0 0 1850 1950 0 1000 3000 -99 3000'/%3E%3C/g%3E%3C/svg%3E");
    background-attachment: fixed;
    background-size: cover;
}

.browser-list {
  list-style-type: none;
  padding-left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  transition: scale;
}

.browser-list li {
  padding: 5px;
  transition: all 0.2s ease-in-out;
}
.browser-list li:hover {
  transform: scale(1.1);
}
.browser-list li:active {
  transform: scale(1.1);
}
.password-icon {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.password-icon:hover {
  color: #00b4b4;
}
.password-icon:active {
  color: #00b4b4;
}

.form-control:focus {
    border-color: #00b4b4;
}
@media (max-width: 399px) {
  #loginContainer {
    width: 90%;
  }
}
@media (min-width: 400px) {
  #loginContainer {
    width: 400px;
  }
}
/* Default Bootstrap input styling (optional, for reference) */
.form-control {
  border: 1px solid #ced4da; /* Bootstrap’s default border */
}

/* Remove focus outline and prevent border darkening */
.form-control:focus {
  outline: none !important; /* No outline */
  box-shadow: none !important; /* No Bootstrap glow */
  -webkit-box-shadow: none !important; /* No Chrome glow */
  border-color: #ced4da !important; /* Lock to Bootstrap’s default border color */
}

/* Handle autofill: no outline, no glow, no blue background */
.form-control:-webkit-autofill,
.form-control:-webkit-autofill:hover,
.form-control:-webkit-autofill:focus,
.form-control:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #fff inset !important; /* Force white background */
  box-shadow: none !important; /* No glow */
  outline: none !important; /* No outline */
  border-color: #ced4da !important; /* Match Bootstrap’s default border */
  -webkit-text-fill-color: #495057 !important; /* Match Bootstrap’s text color */
}

/* Disabled inputs */
.form-control:disabled,
.form-control:disabled:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: #ced4da !important; /* Keep default border */
  background-color: #e9ecef !important; /* Bootstrap’s disabled bg */
}
</style>
